import { FC, useState } from "react";
import { AnimatePresence } from "framer-motion";

import {
  ProductionSceneActorResource,
  ProductionSceneResource,
} from "@/types/resources";
import {
  InfoBlock,
  InfoHeadline,
  PlusButton,
} from "./ProductionScriptBlockInfo";
import ActorsModal from "./ActorsModal";
import Text from "@/components/Text";

interface Props {
  actors?: ProductionSceneActorResource[][];
  scene: ProductionSceneResource;
  sceneNumber: number;
}

const SidebarActors: FC<Props> = ({ actors, scene, sceneNumber }) => {
  const [showModal, setShowModal] = useState(false);

  const sceneActors = actors?.[sceneNumber - 1];

  return (
    <>
      <InfoHeadline
        $type="smallBold"
        as="button"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <PlusButton>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.75 0.749023C3.75 0.33481 3.41421 -0.000976562 3 -0.000976562C2.58579 -0.000976562 2.25 0.33481 2.25 0.749023V2.25098H0.749023C0.33481 2.25098 -0.000976562 2.58676 -0.000976562 3.00098C-0.000976562 3.41519 0.33481 3.75098 0.749023 3.75098H2.25V5.25095C2.25 5.66516 2.58579 6.00095 3 6.00095C3.41421 6.00095 3.75 5.66516 3.75 5.25095V3.75098H5.25095C5.66516 3.75098 6.00095 3.41519 6.00095 3.00098C6.00095 2.58676 5.66516 2.25098 5.25095 2.25098H3.75V0.749023Z"
              fill="currentColor"
            />
          </svg>
        </PlusButton>
        Actors
      </InfoHeadline>
      {!!sceneActors?.length ? (
        sceneActors.map((actor) => (
          <InfoBlock key={actor.id}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0001 12.2864C12.5249 12.2864 14.5716 10.2397 14.5716 7.71498C14.5716 5.19025 12.5249 3.14355 10.0001 3.14355C7.47541 3.14355 5.42871 5.19025 5.42871 7.71498C5.42871 10.2397 7.47541 12.2864 10.0001 12.2864Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M3.07129 16.2855C3.77383 15.0694 4.78401 14.0597 6.00035 13.3577C7.21669 12.6557 8.59634 12.2861 10.0007 12.2861C11.4051 12.2861 12.7848 12.6557 14.0011 13.3578C15.2174 14.0598 16.2276 15.0696 16.9301 16.2856"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <Text $type="smallBold" $color="black">
              {actor.role}
            </Text>
          </InfoBlock>
        ))
      ) : (
        <InfoBlock>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0001 12.2864C12.5249 12.2864 14.5716 10.2397 14.5716 7.71498C14.5716 5.19025 12.5249 3.14355 10.0001 3.14355C7.47541 3.14355 5.42871 5.19025 5.42871 7.71498C5.42871 10.2397 7.47541 12.2864 10.0001 12.2864Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
            />
            <path
              d="M3.07129 16.2855C3.77383 15.0694 4.78401 14.0597 6.00035 13.3577C7.21669 12.6557 8.59634 12.2861 10.0007 12.2861C11.4051 12.2861 12.7848 12.6557 14.0011 13.3578C15.2174 14.0598 16.2276 15.0696 16.9301 16.2856"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Text $type="smallBold" $color="gray">
            No actors added
          </Text>
        </InfoBlock>
      )}
      <AnimatePresence>
        {!!showModal && (
          <ActorsModal scene={scene} onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarActors;
